import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";
import { faBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useInsideLayout } from "./InsideLayoutContext";
import { SubHeaderStyle } from "./styles";

export const InsideSubHeader: React.FC = () => {
    const ctx = useInsideLayout();
    const { classes } = SubHeaderStyle();

    return ctx.showCloseButtonWhileMenuOpened && ctx.menuOpened
        ? (
            <Stack justifyContent="space-between" alignItems="center" direction="row" className={classes.container} height="inherit">
                <Button
                    color="muted"
                    size="small"
                    sx={{ ml: 1, mr: 1, minWidth: "unset" }}
                    onClick={ctx.toogleMenu}
                >
                    <FontAwesomeIcon icon={faTimesCircle} fixedWidth></FontAwesomeIcon><span>{ctx.closeMenuText}</span>
                </Button>
            </Stack>
        )
        : (
            <Stack justifyContent="space-between" alignItems="center" direction="row" className={classes.container} height="inherit">
                <Button
                    color="muted"
                    size="small"
                    sx={{ ml: 1, mr: 1, minWidth: "unset" }}
                    onClick={ctx.toogleMenu}
                >
                    <FontAwesomeIcon
                        icon={faBars}
                        fixedWidth
                    />
                    <span>MENU</span>
                </Button>

                <Typography variant="h3" component="div">{ctx.subHeaderText}</Typography>
                {ctx.subHeaderDetail && <Typography variant="caption" component="div">{ctx.subHeaderDetail}</Typography>}
            </Stack>
        );
};
